<shared-home-loader *ngIf="isHome"></shared-home-loader>
<shared-expertise-loader *ngIf="isExpertise"></shared-expertise-loader>
<shared-about-loader *ngIf="isAbout"></shared-about-loader>
<shared-contact-loader *ngIf="isContact"></shared-contact-loader>
<shared-big-page-loader *ngIf="isBigPage"></shared-big-page-loader>
